import { render } from "./Setup.vue?vue&type=template&id=0124c111&scoped=true&ts=true"
import script from "./Setup.vue?vue&type=script&lang=ts"
export * from "./Setup.vue?vue&type=script&lang=ts"

import "./Setup.vue?vue&type=style&index=0&id=0124c111&lan=scss&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0124c111"]])

export default __exports__